import React from "react";
import {ResponseStatus} from "./ResponseStatus";
import Notification from "../commons/Notification";
import * as SoundManager from "./SoundManager";

export const updateAlert = (setAlert, resetNavCol, errorNavCol, type, message, soundType) => {
    // Set Alert
    if (typeof type === "undefined") setAlert(null);
    else {
        setAlert(<Notification
            type={type}
            message={message}
            onClose={() => {
                setAlert(null);
                resetNavCol();
            }}
        />);
        if(typeof soundType === "undefined") {
            playSoundByAlertType(type);
        } else {
            SoundManager.playSound(soundType);
        }
    }

    // Set NavBar color
    if (type === "error") errorNavCol();
    else resetNavCol();
}

export function getAlertType(responseStatus) {
    return (responseStatus === ResponseStatus.WARN ? 'warning' : responseStatus.toLowerCase());
}

function playSoundByAlertType(alertType) {
    switch(alertType) {
        case 'success':
            SoundManager.playSuccessSound();
            break;
        case 'warning':
            SoundManager.playWarningSound();
            break;
        default:
            SoundManager.playErrorSound();
    }
}


// WEBPACK FOOTER //
// ./src/components/utils/utils.js